import {createSlice} from '@reduxjs/toolkit';
import { getLegacyDepartamentos } from '../legacy/thunk.js';

export const initialState = {
    legacyDepartamentos: [],
    error: {},
};

const legacyDepartamentosSlice = createSlice({
    name: 'legacyDepartamentos',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getLegacyDepartamentos.fulfilled, (state, action) => {
            state.legacyDepartamentos = action.payload;
        });
        builder.addCase(getLegacyDepartamentos.rejected, (state, action) => {
            state.error = action.payload.error || null;
        });
    }
});

export default legacyDepartamentosSlice.reducer;